import { defineMessages } from "react-intl";

export const searchMessages = defineMessages({
  search: {
    id: "search.action.search",
    defaultMessage: "Search",
  },
});
